
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { FeatureGuard } from "@/components/common/FeatureGuard";
import { ExchangeRateStep } from "@/components/setup-guide/steps/ExchangeRateStep";

export function ExchangeRateSettings() {
  return (
    <FeatureGuard feature="currency_conversion">
      <Card>
        <CardHeader>
          <CardTitle>Currency Conversion Provider</CardTitle>
          <CardDescription>
            Configure which service to use for currency conversion rates
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ExchangeRateStep />
        </CardContent>
      </Card>
    </FeatureGuard>
  );
}
